import request from "../request";
/**
 * 登录
 * @param params 登录参数
 * @returns 登录结果
 */
export const loginByUuid = async (params: any) => {
  return request.post("/userInfo/loginByPsw", {
    data: params,
  });
};
export const loginByEmail = async (params: any) => {
  return request.post(`/userInfo/loginByEmail`, {
    data: params,
  });
};
/**
 * 登录
 *
 * @returns uuid
 */
export const getLoginUuid = async () => {
  return request.get("/paas-common-auth/code");
};
/**
 * 退出登录
 *
 * @returns uuid
 */
export const logout = async () => {
  return request.post(`/userInfo/logout`);
};
/**
 * 修改密码
 *
 * @returns uuid
 */
export const resetPassword = async (params: any) => {
  return request.post("/userInfo/changePsw", {
    data: params,
  });
};
/**
 * 修改密码
 *
 * @returns uuid
 */
export const sendForgetVerifyCode = async () => {
  return request.post("/userInfo/sendForgetVerifyCode", {});
};

/**
 * 获取用户信息
 *
 * @returns user info
 */
export const getUserInfo = async (id: any) => {
  return request.get('/userInfo/' + id);
};
